import {
  animate,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const ECO_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

/** opacity 0 -> 1, translateY(40px) -> 0. Runs once, on 'hidden' => 'shown'. */
export const fadeUp = trigger('fadeUp', [
  state('hidden', style({ opacity: 0, transform: 'translateY(40px)' })),
  state('shown', style({ opacity: 1, transform: 'none' })),
  transition('hidden => shown', animate(`700ms ${ECO_EASE}`)),
]);

/** Header lines land one after another. */
export const headIn = trigger('headIn', [
  transition('hidden => shown', [
    query(':scope > *', style({ opacity: 0, transform: 'translateY(26px)' }), {
      optional: true,
    }),
    query(
      ':scope > *',
      stagger(110, [
        animate(`620ms ${ECO_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);

/** Same reveal, staggered across children marked `.eco-stagger`. */
export const staggerIn = trigger('staggerIn', [
  transition('hidden => shown', [
    query(
      '.eco-stagger',
      style({ opacity: 0, transform: 'translateY(40px)' }),
      { optional: true }
    ),
    query(
      '.eco-stagger',
      stagger(90, [
        animate(`700ms ${ECO_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);

/**
 * The stage reveals from the middle out — the hub first, then the satellites
 * ripple outward, which reads as the network coming online.
 */
export const stageIn = trigger('stageIn', [
  transition('hidden => shown', [
    query('.eco-hub', style({ opacity: 0, transform: 'scale(0.82)' }), {
      optional: true,
    }),
    query('.eco-sat', style({ opacity: 0, transform: 'translateY(26px) scale(0.96)' }), {
      optional: true,
    }),
    query('.eco__links', style({ opacity: 0 }), { optional: true }),
    query(
      '.eco-hub',
      animate(`560ms ${ECO_EASE}`, style({ opacity: 1, transform: 'none' })),
      { optional: true }
    ),
    query(
      '.eco-sat',
      stagger(70, [
        animate(`480ms ${ECO_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
    query('.eco__links', animate(`600ms ${ECO_EASE}`, style({ opacity: 1 })), {
      optional: true,
    }),
  ]),
]);

/** Bottom process flow — each step lands left to right. */
export const stepsIn = trigger('stepsIn', [
  transition('hidden => shown', [
    query('.eco-step', style({ opacity: 0, transform: 'translateX(-24px)' }), {
      optional: true,
    }),
    query(
      '.eco-step',
      stagger(130, [
        animate(`600ms ${ECO_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);
